import type { RequestError } from '@onhandtech/onhand-fe-shared/lib/contracts/requests/requests'
import { addNotification } from '@onhandtech/onhand-fe-shared/lib/notifications'
import type { ReduxModuleResultPayloadAction } from '@onhandtech/onhand-fe-shared/lib/redux'
import { put } from 'redux-saga/effects'

export function* createSignupCodeFailureSaga({
  formatMessage,
}: ReduxModuleResultPayloadAction<RequestError>) {
  if (formatMessage) {
    yield put(
      addNotification({
        id: 'create-code-failure',
        variant: 'error',
        title: formatMessage({
          id: 'notifications.signup-codes.create.failure.title',
        }),
        description: formatMessage({
          id: 'notifications.signup-codes.create.failure.description',
        }),
      }),
    )
  }
}
